// extracted by mini-css-extract-plugin
module.exports = {"button":"mf-Pi","large":"mf-Pj","small":"mf-Pk","icon":"mf-Pl","primary":"mf-Pm","secondary":"mf-Pn","secondaryTransparent":"mf-Po"};